import {updateURLSlugs} from "../../components/naviagtions/itemNavs/itemNavigationFunctions";
import { RECIPE_ACTION_TYPES } from "../actions/recipeActions";
import { Recipe, PaginationInfo } from "../../types/shopify";
import { RecipesState } from "../../types/recipes";

interface recipeAction {
    type: "GET_RECIPES" | "SELECT_RECIPE" | 
          typeof RECIPE_ACTION_TYPES.FETCH_RECIPES | 
          typeof RECIPE_ACTION_TYPES.FETCH_RECIPE | 
          typeof RECIPE_ACTION_TYPES.SEARCH_RECIPES | 
          typeof RECIPE_ACTION_TYPES.SET_LOADING_STATE | 
          typeof RECIPE_ACTION_TYPES.SET_ERROR_STATE;
    recipesData?: RecipeData[];
    itemsData?: ItemData[];
    selectedRecipe?: RecipeData | null;
    payload?: Recipe[] | Recipe;
    paginationInfo?: PaginationInfo;
    searchTerm?: string;
    isLoading?: boolean;
    error?: string | null;
}

const initialState: RecipesState = {
    recipesData: [],
    itemsData: [],
    shopifyRecipes: [],
    currentRecipe: null,
    recipeCount: 0,
    paginationInfo: {
        hasNextPage: false,
        endCursor: null,
        collectionHandle: null,
        searchTerm: null
    },
    isLoading: false,
    error: null
};

export default function recipeReducer(
    state = initialState,
    action: recipeAction
) {
    switch (action.type) {
        case "GET_RECIPES":
            return {
                ...state,
                recipesData: action.recipesData || [],
            };
        case "SELECT_RECIPE":
            // change the url to reflect the recipe we are in
            // TODO: update urls
//            updateURLSlugs(action.selectedRecipe, state.selectedRecipe);
            return {
                ...state,
                selectedRecipe: action.selectedRecipe,
                itemsData: action.itemsData || []
            };
        
        // Shopify blog article (recipe) actions
        case RECIPE_ACTION_TYPES.FETCH_RECIPES: {
            const recipes = action.payload as Recipe[] || [];
            return {
                ...state,
                shopifyRecipes: recipes,
                recipeCount: recipes.length,
                paginationInfo: action.paginationInfo || initialState.paginationInfo,
                error: null
            };
        }
        
        case RECIPE_ACTION_TYPES.SEARCH_RECIPES: {
            const recipes = action.payload as Recipe[] || [];
            return {
                ...state,
                shopifyRecipes: recipes,
                recipeCount: recipes.length,
                paginationInfo: {
                    ...action.paginationInfo,
                    searchTerm: action.searchTerm || null
                } || initialState.paginationInfo,
                error: null
            };
        }
        
        case RECIPE_ACTION_TYPES.FETCH_RECIPE:
            return {
                ...state,
                currentRecipe: action.payload as Recipe,
                error: null
            };
            
        case RECIPE_ACTION_TYPES.SET_LOADING_STATE:
            return {
                ...state,
                isLoading: action.isLoading || false
            };
            
        case RECIPE_ACTION_TYPES.SET_ERROR_STATE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
            
        default:
            return state;
    }
}